/**
 * PWA 자동 업데이트 모듈
 *
 * Capacitor WebView에서는 브라우저 새로고침이 불가능하므로,
 * 새 Service Worker가 감지되면 즉시 업데이트를 적용하고 페이지를 reload한다.
 * 1시간 간격으로 주기적으로 업데이트를 체크한다.
 */
import { registerSW } from "virtual:pwa-register";
import { createLogger } from "@ict/shared/logger";

const logger = createLogger({ module: "PWA-Update" });

// 1시간마다 업데이트 체크
const UPDATE_INTERVAL_MS = 60 * 60 * 1000;

/**
 * PWA Service Worker 등록 및 자동 업데이트 초기화
 *
 * - onNeedRefresh: 새 버전 감지 시 즉시 updateSW() 호출 (자동 reload)
 * - onOfflineReady: 오프라인 캐시 준비 완료 로그
 * - onRegisteredSW: 주기적 업데이트 체크 설정
 */
export function initPwaUpdate(): void {
  const updateSW = registerSW({
    onNeedRefresh() {
      // Capacitor 앱에서는 사용자 확인 없이 즉시 업데이트 적용
      logger.info("새 버전 감지 - 자동 업데이트 적용 중");
      updateSW(true);
    },
    onOfflineReady() {
      logger.info("오프라인 사용 준비 완료");
    },
    onRegisteredSW(swUrl, registration) {
      if (!registration) return;

      logger.info(`Service Worker 등록 완료: ${swUrl}`);

      // 주기적 업데이트 체크
      setInterval(() => {
        if (registration.installing || !navigator) return;

        // navigator.onLine 체크: 오프라인이면 체크 생략
        if (!navigator.onLine) return;

        logger.debug("주기적 SW 업데이트 체크 실행");
        registration.update().catch((err: unknown) => {
          logger.warn("SW 업데이트 체크 실패", err);
        });
      }, UPDATE_INTERVAL_MS);
    },
    onRegisterError(error) {
      logger.error("Service Worker 등록 실패", error);
    },
  });
}
